export enum H2sItemTitle {
  TOTAL = 'Total',
}
